import { ApolloLink } from "@apollo/client";

export const loggerResponse = new ApolloLink((operation, forward) => {
  console.log("Start", operation.operationName);
  return forward(operation).map((result) => {
    console.log("Finish", operation.operationName);
    return result;
  });
});
